import {SmartAdSASTypes} from "../../offer/helpers/smart_add_sas_types";
import {INTERNAL_BANNERS} from "../constants/internal_banners";

export const getInternalBanner = (adFormat: number) => {
    if (adFormat !== SmartAdSASTypes.HERO) {
        return;
    }

    return INTERNAL_BANNERS[0];
};
import {SmartAdSASTypes} from "../../offer/helpers/smart_add_sas_types";
import {INTERNAL_BANNERS} from "../constants/internal_banners";

export const getInternalBanner = (adFormat: number) => {
    if (adFormat !== SmartAdSASTypes.HERO) {
        return;
    }

    return INTERNAL_BANNERS[0];
};
